import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, Grid, Stack, Tooltip } from "@mui/material";
import { connect } from 'react-redux';
import { Card, CardBody } from "reactstrap";
import CustomTextField from "../../../components/Form/CustomTextField";
import "../../Orders/order.css";

const Shipping = ({ setFormValues, values, error }) => {
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <Card className="p-3 px-2" style={{ minHeight: "40vh" }}>
          <CardBody>
            <div className="setting-header">SHIPPING</div>
            <Divider className="my-2 mb-2" />
            <Grid container spacing={2} pt={2}>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  title={'Weight'}
                  type="number"
                  values={values?.weight_in_gram}
                  error={error && error.weight_in_gram}
                  onChange={(e) => setFormValues((prevValues) => ({
                    ...prevValues,
                    weight_in_gram: e
                  }))}
                  InputProps={{
                    endAdornment: <div
                      style={{
                        color: "#00000099",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "8px",
                      }}
                    >
                      <div
                        style={{
                          height: "1.5em",
                          borderLeft: "1px solid #c4c4c4",
                          marginRight: "8px",
                        }}
                      ></div>
                      g
                    </div>,
                  }}
                  placeholder="0"
                />
              </Grid>
              <Grid item xs={12}>
                <span style={{ fontFamily: 'Manrope-SemiBold', fontSize: 14, color: "#00000099" }}>Parcel Size</span>
              </Grid>
              <Grid item xs={12} style={{ paddingTop: "0px", }}>
                <Stack flexDirection={{ xs: "column", sm: "row" }} spacing={{ xs: 0, sm: 2 }} alignItems={{ xs: "center", sm: "flex-end" }}>
                  <CustomTextField
                    values={values?.length_in_mm}
                    error={error && error.length_in_mm}
                    InputProps={{
                      endAdornment: <div
                        style={{
                          color: "#00000099",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "8px",
                        }}
                      >
                        <div
                          style={{
                            height: "1.5em",
                            borderLeft: "1px solid #c4c4c4",
                            marginRight: "8px",
                          }}
                        ></div>
                        cm
                      </div>,
                    }}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      length_in_mm: e
                    }))}
                    placeholder="Depth"
                  /> <i className="ri-close-fill" style={{ fontSize: 30 }} />

                  <CustomTextField
                    values={values?.width_in_mm}
                    error={error && error.width_in_mm}
                    InputProps={{
                      endAdornment: <div
                        style={{
                          color: "#00000099",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "8px",
                        }}
                      >
                        <div
                          style={{
                            height: "1.5em",
                            borderLeft: "1px solid #c4c4c4",
                            marginRight: "8px",
                          }}
                        ></div>
                        cm
                      </div>,
                    }}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      width_in_mm: e
                    }))}
                    placeholder="Width"
                  /> <i className="ri-close-fill" style={{ fontSize: 30 }} />

                  <CustomTextField
                    values={values?.height_in_mm}
                    error={error && error.height_in_mm}
                    InputProps={{
                      endAdornment: <div
                        style={{
                          color: "#00000099",
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "8px",
                        }}
                      >
                        <div
                          style={{
                            height: "1.5em",
                            borderLeft: "1px solid #c4c4c4",
                            marginRight: "8px",
                          }}
                        ></div>
                        cm
                      </div>,
                    }}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      height_in_mm: e
                    }))}
                    placeholder="Height"
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextField
                  title={<>Lead Time (optional){
                    <Tooltip title={'Number of business days between order receiving and delivery to customer.'} className="mx-1" placement="top"><i className="ri-information-line" /></Tooltip>
                  }</>}
                  type="number"
                  values={values?.lead_time}
                  error={error && error.lead_time && "The lead time field is required when platform availability includes Ariba."}
                  onChange={(e) => setFormValues((prevValues) => ({
                    ...prevValues,
                    lead_time: e
                  }))}
                  InputProps={{
                    endAdornment: <div
                      style={{
                        color: "#00000099",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "8px",
                      }}
                    >
                      <div
                        style={{
                          height: "1.5em",
                          borderLeft: "1px solid #c4c4c4",
                          marginRight: "8px",
                        }}
                      ></div>
                      days
                    </div>,
                  }}
                  placeholder="0"
                />              </Grid>
            </Grid>
          </CardBody>
        </Card>
      </div>
    </React.Fragment >
  );
};

function mapStateToProps({ }) {
  return {

  };
}


export default connect(mapStateToProps)(Shipping);
